import { Layout } from '@myua/kit';
import { PlayCircle } from '@myua/icons/dist/bold24';
import { FC, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { Header } from '../../../../general/components/Header/HeaderDefault';
import type { HeaderInfoMenuItem } from '../../../../general/components/Header/initHeader';
import { LayoutSiderLeft } from './LayoutSiderLeft';
import { LayoutSiderRight } from './LayoutSiderRight';
import { useSelector } from 'react-redux';
import { getSidebarDragging, getSlowNetwork } from '../selectors';
import { getSlotDragging } from '../../finder/selectors';
import { routes } from '../../router/model';
import { showGetStartedWidget } from '../../getStarted';
import { GET_STARTED_ENABLED } from '../../getStarted/config';
import { SlowNetworkBadge } from '../../../../general/components/SlowNetworkBadge/SlowNetworkBadge';

export const AppLayout: FC<{ leftSider: boolean; rightSider: boolean }> = ({
  children,
  leftSider,
  rightSider,
}) => {
  const sidebarDragging = useSelector(getSidebarDragging);
  const slotDragging = useSelector(getSlotDragging);
  const slowNetwork = useSelector(getSlowNetwork);
  const history = useHistory();

  // Пункт «Tutorial» в дропдауне Teacher (только Asset Lab). Клик с любой страницы:
  // сначала навигируем на Catalog (единственная точка монтирования виджета), затем
  // показываем виджет. Мемоизируем по history (стабилен) — initHeader вызывается один раз.
  const infoMenuItems = useMemo<HeaderInfoMenuItem[]>(
    () =>
      GET_STARTED_ENABLED
        ? [
            {
              key: 'al-tutorial',
              label: 'Tutorial',
              icon: <PlayCircle />,
              onClick: () => {
                history.push(routes.viewer);
                showGetStartedWidget();
              },
            },
          ]
        : [],
    [history],
  );

  return (
    <>
      <Header serviceKey="assetlab" infoMenuItems={infoMenuItems} />
      <SlowNetworkBadge slow={slowNetwork} />
      <div className="al-app">
        <Layout
          className={`al-app-layout ${sidebarDragging || slotDragging ? 'al-app-layout_dragging' : ''}`}
        >
          {leftSider ? <LayoutSiderLeft /> : null}
          <Layout.Content className="al-app-layout__main">{children}</Layout.Content>
          {rightSider ? <LayoutSiderRight /> : null}
        </Layout>
      </div>
    </>
  );
};
